import React, { useEffect, useState } from 'react';

import { Icon } from 'antd';
import {
  Table,
  ColumnProps,
  FormSwitch,
  Form,
  Row,
  FormInput,
  Col,
  Button,
  FormResetButton,
  InlineEditTable,
  InlineEditColumnProps,
  FormSelect,
  FormTextArea,
  ColumnType,
} from '@digital/ui';
import { Parametro } from '@app/api/parametro';
import { ContratoEspecialTableData } from '@app/api/contratoEspecial';

interface TabelaProps {
  param: Parametro[];
  handleUpdate: (record: Parametro) => void;
}

const handleClick = (value: Parametro) => {
  if (value) {    
  }
};

const handleChange = async (id: string, especial: boolean) => {
  // const result = await updateStatusContratoEspecial(id, especial);
  // setUpdated(!updated);
};

const TableParametro = (props: TabelaProps) => {
  const { param, handleUpdate } = props;

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Parâmetro',
        dataIndex: 'nome',
        width: '30%',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '10%',
        type: ColumnType.Switch,
        renderEdit: () => <FormSwitch name="status" span={3} disabled={false} />,
      },

      {
        title: 'Observação',
        dataIndex: 'observacao',
        renderEdit: () => <FormInput name="observacao" required key="index" />,
        width: '60%',
      },
    ] as InlineEditColumnProps<Parametro>[];
  };

  return (
    <>
      <InlineEditTable
        rowKey="parametroId"
        columns={customColumns()}
        updateItem={handleUpdate}
        dataSource={param || []}
        pagination={false}
        disablenotification={false}
      />
    </>
  );
};

export default TableParametro;
